class ProductStickyBar extends HTMLElement {
  constructor() {
    super();
    // 设置触发显示的滚动距离阈值（单位：像素）
    this.scrollThreshold = document
      .querySelector("product-info")
      .getBoundingClientRect().height;
    this.button = this.querySelector(".product-sticky-bar-cta");
    this.faq = this.querySelector("[data-faq]");
    this.details = this.querySelector("[data-detail]");
    this.reviews = this.querySelector("[data-review]");
  }
  connectedCallback() {
    // 添加滚动事件监听
    window.addEventListener("scroll", () => {
      // 获取当前垂直滚动距离
      const currentScroll =
        window.scrollY || document.documentElement.scrollTop;

      // 判断是否超过阈值
      if (currentScroll > this.scrollThreshold) {
        // 显示元素（修改为实际需要的显示方式）
        this.classList.add("active");
      } else {
        // 隐藏元素
        this.classList.remove("active");
      }
    });
    this.button.addEventListener("click", (e) => {
      e.preventDefault();
      $(document.querySelector("[id^=ProductSubmitButton-]")).click();
      $(this.button).addClass("loading");
    });
    this.faq.addEventListener("click", (e)=>{
      e.preventDefault();
      document.querySelector("[data-product-section-faq]").scrollIntoView({behavior: "smooth"});
    })
    this.reviews.addEventListener("click", (e)=>{
      e.preventDefault();
      document.querySelector("#judgeme_product_reviews").scrollIntoView({behavior: "smooth"});
    })
    this.details.addEventListener("click", (e)=>{
      e.preventDefault();
      // document.querySelector("product-info").style.setProperty("scroll-margin-top", getComputedStyle(document.querySelector("product-info")).height);
      document.querySelector("#MainContent>*:nth-child(2)").scrollIntoView({behavior: "smooth"});
    })
  }
  throttle(func, limit = 100) {
    let lastFunc;
    let lastRan;
    return function () {
      const context = this;
      const args = arguments;
      if (!lastRan) {
        func.apply(context, args);
        lastRan = Date.now();
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(function () {
          if (Date.now() - lastRan >= limit) {
            func.apply(context, args);
            lastRan = Date.now();
          }
        }, limit - (Date.now() - lastRan));
      }
    };
  }
}
if (!customElements.get("product-sticky-bar")) {
  customElements.define("product-sticky-bar", ProductStickyBar);
}
